export const environment = {
  production: true,
  serverUrl: 'https://vrcargo-backend-test.bluesand-67ada09c.northeurope.azurecontainerapps.io/api/v1/',
  authUrl: 'https://vrcargo-backend-test.bluesand-67ada09c.northeurope.azurecontainerapps.io/api/auth/',
  mailSender: 'request@vr-cargo.aero',
};
